import MTable from './MTable';

export default MTable;



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/grid-mobile/index.jsx